export enum HASHTAG_CATEGORY {
  TRAVEL = 'Travel',
  SOCIAL = 'Social',
  BOOKING = 'Booking',
  ECOMMERCE = 'Ecommerce',
}
